<template>
  <van-nav-bar
    :title="title"
    :left-text="leftText"
    :right-text="rightText"
    left-arrow
    :border="border"
    @click-left="onClickLeft"
    @click-right="onClickRight"
    :style="{ paddingTop: `${statusBarH}px`,backgroundColor }"
  >
    <template #left>
      <img class="left" src="../../assets/img/knowledge-base/back.png" />
    </template>

    <template #title>
      <slot name="title"></slot>
    </template>

    <template #right>
      <slot name="right"></slot>
    </template>
  </van-nav-bar>
</template>

<script>
import { NavBar } from 'vant';
export default {
  components: {
    VanNavBar: NavBar,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    leftText: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    backgroundColor:{
      type:String,
      default:'#ffffff'
    },
    border: {
      type: Boolean,
      default: false,
    },
    page: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusBarH: 0,
    };
  },
  computed: {},
  methods: {
    onClickLeft() {
      if (this.page == 'index') {
        this.$bsUtils.nativeApi.goBack();
      } else {
        this.$router.back();
      }
    },
    onClickRight() {},
  },
  async mounted() {
    let { statusBarH } = await this.$bsUtils.nativeApi.getDeviceInfo();
    this.statusBarH = statusBarH;
    this.$bsUtils.nativeApi.setStatusBarColor(0);
  },
};
</script>

<style lang="less" scoped>
.left {
  width: 17px;
  height: 17px;
}
.van-nav-bar {
  background-color: transparent;
  /deep/.van-nav-bar__title {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #111111;
  }
}
</style>